import {NgModule} from '@angular/core';
import {SharedModule} from "../../../shared.module";
import {InitialOrderRewardComponent} from "./initial-order-reward.component";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [InitialOrderRewardComponent],
    exports: [InitialOrderRewardComponent]
})
export class InitialOrderRewardModule {}
